import api from '@/api';

const state = {
    list: [],
    selectedIndex: null,
    selectedLogo: null,
    selected: {},
    patternFields: [],
    uploadFile: null,
    uploadFileData: null,
    error: false,

    cardsList: [],
    dictionary: {
        status: [],
        passtype: [],
        category: [],
        citizenship: [],
        organization: [],
        event: [],
    },
}

const getters = {
    patterns: (state) => {
        return state
    },

    list: (state) => {
        return state.list
    },

    selectedIndex: (state) => {
        return state.selectedIndex
    },

    selectedLogo: (state) => {
        return state.selectedLogo
    },

    selected: (state) => {
        return state.selected
    },

    patternFields: (state) => {
        return state.patternFields
    },

    uploadFile: (state) => {
        return state.uploadFile
    },

    uploadFileData: (state) => {
        return state.uploadFileData
    },

    error: (state) => {
        return state.error
    },

    cardsList: (state) => {
        return state.cardsList
    },

    dictionary: (state) => {
        return state.dictionary
    },
}



const actions = {
    async GetList({ commit }, id) {

        const GetListResult = await api.getUserPatterns(id)

        if (GetListResult.result !== null) {
            commit('setList', GetListResult.result)
            commit('setSelectedIndex', null)
            commit('setSelectedLogo', null)
            commit('setPatternFields', [])
            commit('setUploadFile', null)
            commit('setUploadFileData', null)
        }
        else {
            commit('setList', [])
            commit('setSelectedIndex', null)
            commit('setSelectedLogo', null)
            commit('setPatternFields', [])
            commit('setUploadFile', null)
            commit('setUploadFileData', null)
        }

        return GetListResult;
    },

    async SetSelected({ commit }, id) {

        commit('setSelectedIndex', id);

        const GetPatternResult = await api.getPattern(id)

        if (GetPatternResult.result != null) {
            commit('setSelected', GetPatternResult.result[0]);

            const GetPatternLogoResult = await api.getPatternLogo(id);

            if (GetPatternLogoResult.result != null) {
                commit('setSelectedLogo', GetPatternLogoResult.result);
            }
            else {
                commit('setSelectedLogo', null);
            }

            const getPatternFieldsResult = await api.getPatternFields(id).
                then(res => {
                    if (res.result != null) {
                        // console.log(res.result);
                        // res.result.unshift(
                        // {
                        //     "R_ID_TEMPL_FIELD": 999,
                        //     "R_CODE": "",
                        //     "R_FFIELD": "F",
                        //     "R_FFLAG": 0,
                        //     "R_FORDER": 0,
                        //     "R_FTABLE": "CARD",
                        //     "R_ID_TEMPL": 5,
                        //     "R_NAME": "FIDE NUMBER",
                        //     "R_STRETCH": 0,
                        //     "R_TYPE": 99,
                        //     "R_S_TYPE": "Число",
                        //     "R_S_STRETCH": "",
                        //     "value": null
                        // }
                        // );

                        res.result.forEach(element => {

                            // Этот блок для сохранения уже набитых данных при смене шаблона
                            // Сохранятся данные, у которых совпадают R_FFIELD

                            let find = state.patternFields.find(el => el.R_FFIELD === element.R_FFIELD);

                            if (find != undefined) {
                                element.value = find.value;
                            }
                            else {
                                element.value = null;  // добавим поле val для дальнейшего хранения данных введеных пользователем

                                if (element.R_SQL_RESULT) {
                                    if (element.R_SQL_RESULT.length > 0) {
                                        element.value = element.R_SQL_RESULT[0];
                                    }
                                }
                            }

                            // element.value = null;  // добавим поле val для дальнейшего хранения данных введеных пользователем

                            // if (element.R_SQL_RESULT) {
                            //     if (element.R_SQL_RESULT.length > 0) {
                            //         element.value = element.R_SQL_RESULT[0];
                            //     }
                            // }
                        });

                        res.result.sort((a, b) => (a.R_FORDER - b.R_FORDER));

                        return res;
                    }
                    else {
                        return res;
                    }
                });


            if (getPatternFieldsResult.result != null) {
                commit('setPatternFields', getPatternFieldsResult.result);
            }
            else {
                commit('setPatternFields', null);
            }
        }
        else {
            commit('setSelected', {});
            commit('setSelectedLogo', null);
            commit('setPatternFields', []);
        }

        commit('setUploadFile', null)
        commit('setUploadFileData', null)

        return GetPatternResult;
    },

    Clear({ commit }) {
        commit('setList', []);
        commit('setSelectedIndex', null);
        commit('setSelectedLogo', null);
        commit('setSelected', {});
        commit('setPatternFields', []);
        commit('setUploadFile', null)
        commit('setUploadFileData', null)
    },

    SetUploadFile({ commit }, uploadFile) {
        commit('setUploadFile', uploadFile)
    },

    SetUploadFileData({ commit }, uploadFileData) {
        commit('setUploadFileData', uploadFileData)
    },

    async CreateCard(state, params) {
        const CreateCardResult = await api.createCard(params.userId, params.patternId, params.photo, params.passport, params.agreement);
        return CreateCardResult;
    },

    async AddCardField(state, params) {
        const CreateCardResult = await api.addCardField(params.cardId, params.fieldName, params.fieldValue);
        return CreateCardResult;
    },

    async GetFideInfo(state, id) {
        const GetFideInfoResult = await api.getFideInfo(id);
        return GetFideInfoResult;
    },

    async GetPkInfo(state, id) {
        const GetPkInfoResult = await api.getPkInfo(id);
        return GetPkInfoResult;
    },
    
    async GetFideAPIData(state, id) {
        const GetFideAPIDataResult = await api.getFideAPIData(id);
        return GetFideAPIDataResult;
    },

    async GetCardsList({ commit }, params) {

        // console.log('P_FFLAG=', params.P_FFLAG);
        // console.log('P_DATE_BEG_1=', params.P_DATE_BEG_1);

        const GetListResult = await api.getCards(
            params.P_ID_CARD,
            params.P_FFLAG,
            params.P_ID_USER_SELF,
            params.P_ID_USER,
            params.P_ID_TTYPE,
            params.P_ID_TTYPE_CATEGOR,
            params.P_ID_TTYPE_CITIZEN,
            params. P_ID_TTYPE_STATUS,
            params. P_ID_TTYPE_PASS,
            params.P_ID_ORG,
            params.P_ID_EVENT,
            params.P_F,
            params.P_I,
            params.P_O,
            params.P_F_LAT,
            params.P_I_LAT,
            params.P_DATE_ACT_1,
            params.P_DATE_ACT_2,
            params.P_DATE_BEG_1,
            params.P_DATE_BEG_2,
            params.P_DATE_END_1,
            params.P_DATE_END_2,
            params.P_DATE_BIRTH_1,
            params.P_DATE_BIRTH_2,
            params.P_PASS_DATE_1,
            params.P_PASS_DATE_2,
            params.P_PASS_SER,
            params.P_PASS_NUM,
            params.P_E_MAIL,
            params.P_PHONE,
            params.P_BARCODE,
            params.P_ID_USER_ACCEPT,
            params.P_ID_TTYPE_REASON,
            params.P_RFID,
            params.P_FANID,
            params.P_ID_DEP,
            params.P_ID_EMPL,
            params.P_ID_TTYPE_KPP,
            params.P_ID_TTYPE_DEST
        )

        if (GetListResult.result !== null) {
            commit('setCardsList', GetListResult.result)
        }
        else {
            commit('setCardsList', [])
        }

        return GetListResult;
    },


    async getDictionary({ commit }, DictName) {
        // DictName: status // passtype  // category  // citizenship // organization // event

        const GetListResult = await api.getDictionary(DictName);

        if (GetListResult.result !== null) {
            commit('setDictionary', {dict_name: DictName, list: GetListResult.result} )
        }
        else {
            commit('setDictionary', {dict_name: DictName, list: []})
        }

        return GetListResult;
    },    


    async getDictionaries() {
        // DictName: status // passtype  // category  // citizenship // organization // event
        this.dispatch('patterns/getDictionary', 'status');
        this.dispatch('patterns/getDictionary', 'passtype');
        this.dispatch('patterns/getDictionary', 'category');
        this.dispatch('patterns/getDictionary', 'citizenship');
        this.dispatch('patterns/getDictionary', 'organization');
        this.dispatch('patterns/getDictionary', 'event');
    },    

}

const mutations = {
    setList(state, list) {
        state.list = list
    },

    setSelectedIndex(state, selectedIndex) {
        state.selectedIndex = selectedIndex
    },

    setSelectedLogo(state, selectedLogo) {
        state.selectedLogo = selectedLogo
    },

    setSelected(state, selected) {
        state.selected = selected
    },

    setPatternFields(state, patternFields) {
        state.patternFields = patternFields
    },

    setUploadFile(state, uploadFile) {
        state.uploadFile = uploadFile
    },

    setUploadFileData(state, uploadFileData) {
        state.uploadFileData = uploadFileData
    },

    setCardsList(state, list) {
        state.cardsList = list
    },


    setDictionary(state, {dict_name, list}) {
        state.dictionary[dict_name] = list
        // console.log(dict_name, state.dictionary, list)
    },    
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}